import { Award } from '../../../../types';

export const getSotyBadge = (sotys: (Award | null)[]) =>
  sotys
    .filter(award => award)
    // @ts-ignore
    .sort((a: Award, b: Award) => {
      const nameA = a.name ? a.name.toLowerCase() : null;
      const nameB = b.name ? b.name.toLowerCase() : null;
      if (!a.year) return 1;
      if (!b.year) return -1;
      if (a.year < b.year) return 1;
      if (a.year > b.year) return -1;
      if (a.isPrimary || a.mainAward || a.isSpecial) return -1;
      if (b.isPrimary || b.mainAward || b.isSpecial) return 1;
      if (!nameA) return 1;
      if (!nameB) return -1;
      if (nameA > nameB) return 1;
      if (nameA < nameB) return -1;

      return 0;
    })[0];
